import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=1627655e&"
import script from "./temp.vue?vue&type=script&lang=js&"
export * from "./temp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports